var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.productStarterKitsV2 = {
    attached: false,
    attach: function (context) {
      var self = this;
      var $template = $('.js-starter-kit-v2', context);
      var $viewLink = $('.js-view-link', $template);

      if (self.attached) {
        return;
      }
      self.attached = true;

      $viewLink.once().on('click keydown', function (e) {
        if (e.key === 'Enter' || e.type === 'click') {
          var $detailsSection = $(this).parents('.js-details-section');
          var $truncatedContent = $('.js-details-heading-snippet', $detailsSection);
          var $content = $('.js-details-content', $detailsSection);
          var isExpanded = $detailsSection.attr('aria-expanded') === 'true' ? true : false;

          $truncatedContent.add($content).toggleClass('hidden');
          $content.attr('aria-hidden', isExpanded);
          $detailsSection.attr('aria-expanded', !isExpanded);
          $content.toggleClass('expanded');
        }
      });
    },
    attached: false
  };
})(jQuery);
